
import React from 'react';
import { ColumnsType } from 'antd/es/table';

import IsDataNull from '../../Template/IsDataNull';
import OpenMergeRequestProcessLogModal from './OpenMergeRequestProcessLogModal';

interface HeaderProps {
  data: string;
}

const Header: React.FC<HeaderProps> = ({ data }) => <span>{data}</span>;



const MergeRequestBrandProcessLogTableColumn: ColumnsType<any> = [
  
  {
    title: <Header data={"Created At"} />,
    dataIndex: "createdAt",
    sorter: true,
    width: 100,
   render: (data) => <IsDataNull data={data} />
  },
  {
    title: <Header data={"Message"} />,
    dataIndex: "message",
    sorter: true,
    width: 200,
    render: (data) => <IsDataNull data={data} />,
  },
  {
    title: <Header data={"Description"} />,
    dataIndex: "description",
    sorter: true,
    width: 200,
       render: (data, record, index) => (
        <OpenMergeRequestProcessLogModal data={data} record={record} index={index} />
     
    ),
  },
];
export default MergeRequestBrandProcessLogTableColumn;
